import RegionWorkNumber from "@/models/server/RegionWorkNumber";
import WorkOrderTypeRegion from "@/models/server/WorkOrderTypeRegion";

export default class Region {
    public id: string = "";

    public name: string = "";
    
    public workNumbers: RegionWorkNumber[] = [];

    public workOrderTypeRegions: WorkOrderTypeRegion[] = [];
    
    public isRegion: boolean = false;
}